import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
//import { Button } from '@material-ui/core';
import CardHeader from '@material-ui/core/CardHeader';

import Avatar from '@material-ui/core/Avatar';

import Typography from '@material-ui/core/Typography';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import EmailIcon from '@material-ui/icons/Email';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';

import PropTypes from 'prop-types';

import Skeleton from '@material-ui/lab/esm/Skeleton';
import { Box, TextField, Divider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
//import Footer from '../Complements/Footer';
import moment from 'moment'
//import VoucherPaymentMobile from '../PaymentServiceSwitch/VoucherPaymentMobile';
import VoucherPaymentWeb from '../PaymentServiceSwitch/VoucherPaymentWeb';
// import Title from './../Complements/Title';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { IconButton } from '@mui/material';
import { history } from '../../helpers/history';
import { Add, ArrowBackIos, Favorite } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    root2: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
        position: 'relative',
        minHeight: 300,
    },
    paper: {
        height: 500,
        width: 400,
    },
    control: {
        padding: theme.spacing(2),
    },
    card: {
        height: 500,
        width: 400,
        maxWidth: 345,
        backgroundColor: "#EEEFF2"
    },
    card2: {
        height: 100,
        width: 100,
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: '#b98919',
    },
    fab: {
        position: 'absolute',
        bottom: theme.spacing(5),
        right: theme.spacing(2),
    },
    rowIcon: {
        top: '40%'
    },
    titleDark: {
        // color: '#000000',
        fontWeight: 'bold',
        fontSize: '0.875rem',
        //fontFamily: 'MyriadPro-Bold'
    },
    titleLight: {
        // color: '#000000',
        fontSize: '0.875rem',
        //fontFamily: 'MyriadPro-SemiBold',
        fontWeight: 'bold',
    },
    titleGreenBlackPrimary: {
        color: '#b98919',
        fontSize: '1.05rem',
        //fontFamily: 'MyriadPro-Bold'
    },
    titleGreenBlackSecondary: {
        // color: '#000000',
        fontSize: '1rem',
        //fontFamily: 'MyriadPro-SemiBold'
    },
    divStandard: {
        padding: "20px",
        // border: '2px solid #BEBCC0',
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
}));

const CreditCardPaymentViewWeb = props => {
    const classes = useStyles();
    const { user, openBeneficiaryList, beneficiarySelected, transferForm, dialogOTP, tittle,
        openDialogBeneficiaryForm, balances, accountSelected, changeAccount, isviewvoucher, responseservertransfer, handleDownloadVoucher, handleDownloadDevice, handleConvertMask, onActionAfter } = props
    const { user: owner, name, /* accname, */ number, type_name } = beneficiarySelected
    const permissions = useSelector(state => state.permissions)
    // console.log(beneficiarySelected)
    //const { monto, numeroCuentaDestino, fecha, numeroCuentaOrigen, tipoCuentaOrigen, nombreBeneficiario, tipoCuentaDestino, institucion, comision, concepto } = responseservertransfer;
    // console.log(accountSelected)
    return (
        <div>
            <Grid xs={12} >
                <Typography><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>{tittle.toUpperCase()}</Typography>
            </Grid>
            <Grid container className={classes.root} justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                    <Grid container spacing={5}>
                        <Grid item xs={12} md={6} lg={6} /* className={classes.divStandard} */>
                            {/* <Title>Ordenante</Title> */}
                            <div className={classes.divStandard}>
                                <List className={classes.root}>
                                    <ListItem alignItems="flex-start">
                                        <ListItemAvatar>
                                            <Avatar aria-label="recipe" className={classes.avatar}>
                                                {user ? user.Name.charAt(0) : <Skeleton variant="circle" width={40} height={40} />}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={<span className={classes.titleDark}>
                                                {
                                                    user ? user.Name : <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />
                                                }
                                            </span>}
                                            secondary={
                                                <>
                                                    <span className={classes.titleLight}>
                                                        {
                                                            balances ? `${accountSelected.PRODUCTALIAS}` : <Skeleton height={10} width="40%" />
                                                        }
                                                    </span>
                                                    <br></br>
                                                    <span className={classes.titleLight}>
                                                        {
                                                            balances ? `${handleConvertMask(accountSelected.PRODUCTBANKID)}` : <Skeleton height={10} width="40%" />
                                                        }
                                                    </span>
                                                </>
                                            }
                                        />
                                    </ListItem>
                                </List>

                                <Divider></Divider>
                                <br></br>
                                <Autocomplete
                                    id="combo-box-demo"
                                    className={classes.titleLight}
                                    value={accountSelected}
                                    options={balances}
                                    onChange={(e, nv) => {
                                        changeAccount(nv)
                                    }}
                                    disableClearable
                                    getOptionLabel={(option) => `${handleConvertMask(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
                                    renderOption={(option) => (
                                        <React.Fragment>
                                            {`${handleConvertMask(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Seleccione una cuenta" variant="outlined" fullWidth />}
                                />
                                <br></br>
                                <Divider></Divider>
                                {
                                    user ?
                                        <List className={classes.root}>
                                            <ListItem >
                                                <ListItemAvatar >
                                                    <Avatar style={{ color: '#2E2757', backgroundColor: '#EEEFF2' }}>
                                                        {user ? <LocalAtmIcon /> : <Skeleton variant="circle" width={40} height={40} />}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                {
                                                    user ?
                                                        <ListItemText

                                                            primary={
                                                                <span className={classes.titleGreenBlackSecondary}>
                                                                    Saldo Disponible
                                                                </span>
                                                            }
                                                            secondary={
                                                                <span className={classes.titleGreenBlackPrimary}>
                                                                    {(permissions.includes(11) ?  `$ ${accountSelected.SALDOINT}` : '****.**')}
                                                                </span>
                                                            } /> :
                                                        <ListItemText
                                                            primary={<Skeleton variant="text" />}
                                                            secondary={<Skeleton variant="text" />} />
                                                }

                                            </ListItem>
                                            <ListItem >
                                                <ListItemAvatar>
                                                    <Avatar style={{ color: '#2E2757', backgroundColor: '#EEEFF2' }}>
                                                        {user ? <MailOutlineIcon /> : <Skeleton variant="circle" width={40} height={40} />}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                {
                                                    user ?
                                                        <ListItemText
                                                            primary={<span className={classes.titleGreenBlackSecondary}>
                                                                Correo Electrónico
                                                            </span>}

                                                            secondary={<span className={classes.titleGreenBlackSecondary}>
                                                                {user.Mail}
                                                            </span>} /> :
                                                        <Box pt={0.5}>
                                                            <Skeleton />
                                                            <Skeleton width="60%" />
                                                        </Box>
                                                }

                                            </ListItem>
                                        </List> :
                                        <div>
                                            <CardHeader
                                                avatar={
                                                    <Avatar aria-label="recipe" >
                                                        <Skeleton variant="circle" width={40} height={40} />
                                                    </Avatar>
                                                }
                                                title={<Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                                subheader={<Skeleton height={10} width="40%" />}
                                            />
                                            <CardHeader
                                                avatar={
                                                    <Avatar aria-label="recipe" >
                                                        <Skeleton variant="circle" width={40} height={40} />
                                                    </Avatar>
                                                }
                                                title={<Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                                subheader={<Skeleton height={10} width="40%" />}
                                            />
                                        </div>
                                }
                            </div>

                        </Grid>
                        <Grid item xs={12} md={6} lg={6} /* className={classes.divStandard} */>
                            <div className={classes.divStandard}>
                                {(isviewvoucher === false) ?
                                    <React.Fragment>
                                        {(beneficiarySelected.name) && <List className={classes.root}>
                                            <ListItem alignItems="flex-start">
                                                <ListItemAvatar>
                                                    <Avatar aria-label="recipe" className={classes.avatar}>
                                                        {owner ? name.charAt(0) : 'SN'}
                                                    </Avatar>

                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={owner ? name : 'Seleccione una tarjeta de crédito'}
                                                    secondary={owner ? `${type_name} - ${handleConvertMask(number)}` : '---'}
                                                />
                                            </ListItem>
                                        </List>}

                                        <Typography variant="body2" color="textSecondary" component="p"></Typography>
                                        {owner ?
                                            transferForm
                                            :
                                            <List className={classes.root}>
                                                <ListItem button onClick={() => openBeneficiaryList()} >
                                                    <ListItemAvatar>
                                                        <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                                                            <Favorite />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={"Seleccione tarjeta de crédito"} secondary="" />
                                                </ListItem>
                                                <ListItem button onClick={() => openDialogBeneficiaryForm()} >
                                                    <ListItemAvatar>
                                                        <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                                                            <Add />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={"Agregar tarjeta de crédito"} secondary="" />
                                                </ListItem>
                                            </List>
                                        }
                                    </React.Fragment>
                                    :
                                    <VoucherPaymentWeb
                                        monto={parseFloat(responseservertransfer.monto).toFixed(2)}
                                        titleheader={"PAGO EXITOSO"}
                                        title={"PAGO DE TARJETA DE CRÉDITO"}
                                        typesizegrid={6}
                                        viewVoucher={false}
                                        titleone={"DATOS EMISOR"}
                                        databodyone={[
                                            {
                                                title: "# Socio",
                                                value: responseservertransfer.numeroCliente,
                                                order: 1
                                            },
                                            {
                                                title: "Socio",
                                                value: responseservertransfer.nombreCliente,
                                                order: 2
                                            },
                                            {
                                                title: "Número de cuenta",
                                                value: handleConvertMask(responseservertransfer.numeroCuentaOrigen),
                                                order: 3
                                            },
                                            {
                                                title: "Fecha",
                                                value: moment(responseservertransfer.fecha).format("YYYY-MM-DD"),
                                                order: 4
                                            },
                                            {
                                                title: "Concepto",
                                                value: responseservertransfer.concepto,
                                                order: 5
                                            },
                                            {
                                                title: "Dcto. de transacción",
                                                value: responseservertransfer.numeroMensajeTransaccion,
                                                order: 6
                                            },
                                            {
                                                title: "Dispositivo",
                                                value: responseservertransfer.dispositivo,
                                                order: 7
                                            },
                                            {
                                                title: "Comisión",
                                                value: "$ " + parseFloat(responseservertransfer.comision).toFixed(2),
                                                order: 8
                                            }
                                        ]}
                                        titletwo={"DATOS BENEFICIARIO"}
                                        databodytwo={[
                                            {
                                                title: "Identificación",
                                                value: responseservertransfer.identificacionDestino,
                                                order: 1
                                            },
                                            {
                                                title: "Nombre",
                                                value: responseservertransfer.nombreBeneficiario,
                                                order: 2
                                            },
                                            {
                                                title: "Institución",
                                                value: responseservertransfer.institucion,
                                                order: 3
                                            },
                                            {
                                                title: "Número de Tarjeta",
                                                value: handleConvertMask(responseservertransfer.numeroTarjetaCredito),
                                                order: 4
                                            }
                                        ]}
                                        handleDownloadVoucher={handleDownloadVoucher}
                                        handleDownloadDevice={handleDownloadDevice}
                                        handleResetPayment={onActionAfter}
                                    />

                                }
                            </div>


                        </Grid>
                    </Grid>

                    {/* <Footer /> */}
                </Grid>
            </Grid>
            {dialogOTP}
        </div>
    );
};

CreditCardPaymentViewWeb.propTypes = {
    user: PropTypes.object.isRequired,
};

export default CreditCardPaymentViewWeb;
